export default __webpack_public_path__ + "static/logo-9-f346378532669b20c81a22ea14d55570.png";